<template>
  <div class="h-full overflow-hidden flex flex-col">
    <ThreadsNav :show-center="false" :show-back="$route.query.isSub">
      <template #right>
        <CrystalPowerCount />
      </template>
    </ThreadsNav>

    <div class="flex-1 overflow-auto h-full">
      <ThreadList
        ref="list"
        :on-pull-load="() => reload()"
        :on-scroll-load="() => momentStore.fetchTreeholeMomentList()"
        @on-scroll="(h) => (height = h)"
        class="px-2"
        :need-login="false"
        :show-bottom-tip="momentStore.treeholeMomentList.length > 0"
      >
        <div class="pt-2 pb-2 bg-base-100 rounded-xl mb-2">
          <div class="flex flex-col gap-1 mb-3 bg-base-200 p-4 rounded">
            <p class="text-base font-bold leading-tight">{{ title }}</p>
            <p class="text-base-content/70 text-xs leading-snug">
              {{ $t("treehole.msg") }}
            </p>
          </div>

          <div class="flex gap-2">
            <button
              class="btn btn-primary btn-sm flex-1 flex items-center justify-center gap-1"
              @click="clickAddTreehole"
            >
              <i class="iconify mingcute--add-fill w-4"></i>
              <span>{{ $t("treehole.say") }}</span>
            </button>

            <button
              class="btn btn-sm flex items-center justify-center gap-1"
              style="min-width: 0"
              @click="clickConnect"
            >
              <i class="iconfont icon-connection1"></i>
              <span>{{ $t("treehole.myConnect") }}</span>
            </button>
          </div>
        </div>

        <div
          class="bg-base-200 rounded px-4 pt-2"
          v-if="momentStore.treeholeMomentList.length > 0"
        >
          <TreeholeThreadItem
            v-for="moment in momentStore.treeholeMomentList"
            :key="moment.uuid"
            :moment="moment"
            enable-audio-play
            enable-show-more-link
            showReplyList
            @reaction-click="onActionClick"
            isTreehole
            class="mb-2 last:mb-0"
          />
        </div>
      </ThreadList>
    </div>
    <moment-actions v-model:show="showActions" :moment="toOperateMoment" />
  </div>
</template>

<script setup lang="ts">
import { ThreadListInstance } from "@/components/mobile/ThreadList.vue";
import { useMate } from "@/stores/mate";
import { useMoment } from "@/stores/moment";
import { Moment } from "@/types/entity";
import { onActivated, ref, UnwrapRef } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

// 这里可以引入实际的树洞数据和API

const mateStore = useMate();
const router = useRouter();
const momentStore = useMoment();
const list = ref<ThreadListInstance>();
const height = ref(0);
const { t } = useI18n();

const getTitleAndDesc = () => {
  const hour = new Date().getHours();
  const min = new Date().getMinutes();
  const baseMin = 30;
  const operator = min < baseMin ? "<" : ">=";
  return t(`homeGreeting.${hour}${operator}${baseMin}.title`, {
    name: mateStore.userMate?.name,
  });
};
const title = ref<string>(getTitleAndDesc());

const clickAddTreehole = () => {
  router.push("/mate/treehole/create");
};

const clickConnect = () => {
  router.push("/mate/treehole/connect");
};
const reload = async () => {
  momentStore.treeholeUuidList = [];
  list.value?.resetScrollLoadingState();
};

const showActions = ref(false);
const toOperateMoment = ref<Moment | undefined>(undefined);
const onActionClick = (moment: UnwrapRef<Moment>) => {
  toOperateMoment.value = moment;
  showActions.value = true;
};

onActivated(() => {
  title.value = getTitleAndDesc();
  if (list.value && height.value > 0) {
    list.value.scrollTo(height.value);
  }
  momentStore.updateTreeholeMomentList();
});
</script>
